export default {
    messages: {
        "navbar.links.discover": "ACERCA DO UBISOFT+",
        "navbar.links.store": "Loja",
        "navbar.links.news": "Notícias",
        "navbar.links.forum": "Fórum",
        "navbar.links.support": "Suporte",
        "navbar.links.status": "O meu estado",
        "navbar.links.featured": "Em destaque",
        "navbar.links.rewards": "Resgatar",
        "navbar.links.library": "Todos os jogos",
        "navbar.links.benefits": "Recompensas UBISOFT+",
        "navbar.links.subscription": "Gerir a minha assinatura",
        "navbar.links.cloud": "Cloud available",
        "heading.all_games": "Todos os jogos",
        "heading.my_games": "Continuar a jogar",
        "heading.popular_games": "Os mais populares",
        "heading.recommended_games": "Recomendado para ti",
        "action.load_more_games": "Carregar mais",
        "action.search_for_game": "Procurar jogos",
        "action.launch_game": "Iniciar o jogo",
        "action.activate_game": "Ativar o jogo",
        "filters.brand": "Filtrar por Marca",
        "filters.game_name": "A - Z",
        "filters.release_date": "Data de lançamento",
        "filters.show_all": "Mostrar todos",
        "filters.sort": "Ordenar por",
        "filters.all": "Todos",
        "filters.activated": "Ativados",
        "message.no_activated_games": "Não existem jogos ativados correspondentes com a tua procura",
        "message.already_owned": "Já tens este jogo",
        "message.no_available_games": "Não existem jogos disponíveis correspondentes com a tua procura",
        "message.no_search_results": "Não existem jogos disponíveis correspondentes com a tua procura",
        "message.error": "Lamentamos! Ocorreu um erro ao processar o teu pedido",
        "message.refresh_page": "Clique aqui para tentar novamente",
        "message.no_subscription": "Você não tem uma assinatura ativa",
        "warning.savefiles_alert.title": "Mensagem importante acerca de ficheiro de jogo guardados",
        "warning.savefiles_alert.body": "Atualizar para a edição disponível no UBISOFT+ irá afetar os teus ficheiros de jogo guardados, incluindo o teu progresso no jogo. Se a tua assinatura no UBISOFT+ terminar, terás de comprar o Season Pass para carregar qualquer conteúdo dos teus ficheiros de jogo guardados (incluindo o teu progresso no jogo atual). Para obteres mais informação, consulta os artigos {here}.",
        "warning.savefiles_alert.body.here": "aqui",
        "warning.savefiles_alert.cancel": "Voltar",
        "warning.savefiles_alert.confirm": "Confirmar",
        "warning.mobile_launch_alert.body": "{game} foi adicionado aos teus jogos. Inicia o Uplay no teu PC para jogares.",
        "footer.copyright": "© {year} Ubisoft Entertainment. All Rights Reserved. Ubisoft, Ubi.com and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries",
        "footer.links.ubi_link_label": "ubisoft.com",
        "footer.links.terms_of_use_label": "Termos da Assinatura",
        "footer.links.privacy_policy_label": "Política de Privacidade",
        "footer.links.legal_label": "Informações Legais",
        "hero.title": "Serviço de assinatura da Ubisoft",
        "hero.subtitle": "Acesso ilimitado a mais de 100 jogos | Cancela quando quiseres",
        "hero.buttons.subscribe": "Subscreve já",
        "hero.buttons.login": "Iniciar sessão",
        "hero.buttons.browse": "Ver todos os jogos",
        "progression.benefits.description": "Desbloqueia os nossos mundos e conquista os teus. Queremos recompensar a tua lealdade! Obtém novos itens de jogo todos os meses.\r\nQuanto mais tempo permaneceres no serviço Ubisoft+, mais recompensas poderás resgatar!",
        "progression.benefit.singular.reward": "recompensa",
        "progression.benefit.plural.reward": "recompensas",
        "progression.benefit.singular.benefit": "benefício",
        "progression.benefit.plural.benefit": "benefícios",
        "progression.benefit.singular.booster": "aumento",
        "progression.benefit.plural.booster": "aumentos",
        "progression.level.subscribed_for": "Um assinante do UBISOFT+ há",
        "progression.level.new_subscriber": "Novo assinante",
        "progression.level.new_subscribers": "Novos assinantes",
        "progression.level.subscription.first_month": "1st month",
        "progression.level.subscription.starting_with_months": "{months}+ months",
        "general.date.month": "mês",
        "general.date.months": "meses",
        "general.date.month_remaining": "mês restante",
        "general.date.months_remaining": "meses restantes",
        "rewards.monthly_rewards": "As tuas recompensas mensais",
        "rewards.trial_info": "Free trial",
        "rewards.left": "{time_left} restantes para resgatar {rewards_left} recompensa(s) deste mês",
        "rewards.current_title": "Recompensas deste mês",
        "rewards.previous_title": "Recompensas anteriores",
        "rewards.upcoming_title": "Próximas recompensas",
        "rewards.none_found": "Nenhuma recompensa encontrada",
        "rewards.available": "Disponível",
        "rewards.locked": "Bloqueado",
        "rewards.claimed": "Resgatado",
        "rewards.claim": "Sim",
        "rewards.cancel": "Cancelar",
        "rewards.confirm": "Queres resgatar esta recompensa?",
        "rewards.none_left": "Já resgataste todas as recompensas deste mês",
        "rewards.already_claimed": "Já resgataste esta recompensa",
        "rewards.claim_confirm": "Esta recompensa já foi enviada para o teu jogo!",
        "rewards.close": "Recebi!",
        "rewards.load_more": "Carregar mais",
        "external.links.actions.go": "Go",
        "external.links.actions.more_info": "More Info",
        "external.links.actions.learn_more": "Learn More"
    }
};